<script setup lang="ts">
import {onMounted, ref} from "vue";
import {conversationApi} from "@/container";
import {ConversationMessage} from "@/conversation/interfaces";
import ConversationMessagesTable from "@/conversation/components/ConversationMessagesTable.vue";

const props = defineProps<{
    programId: string;
}>();

const messages = ref<ConversationMessage[]>();
const loading = ref(false);
const total = ref(0);
const page = ref(1);
const limit = ref(20);

const fetchMessages = () => {
    loading.value = true;

    conversationApi().conversationMessages({
        page: page.value,
        limit: limit.value,
        sourceable_type: 'program',
        sourceable_id: Number(props.programId)
    })
        .then(response => {
            messages.value = response.data;
            total.value = response.meta?.total ?? 0;
        })
        .finally(() => {
            loading.value = false;
        });
};

const handlePageChange = (newPage: number) => {
    if (newPage === page.value) {
        return;
    }

    page.value = newPage;
    fetchMessages();
};

const handleLimitChange = (newLimit: number) => {
    if (newLimit === limit.value) {
        return;
    }

    page.value = 1;
    limit.value = newLimit;
    fetchMessages();
};

onMounted(() => {
    fetchMessages();
});
</script>

<template>
  <div class="p-4 flex flex-col gap-2">
    <h1>Historique des messages envoyés</h1>
    <div class="shadow-md rounded-lg">
      <ConversationMessagesTable
        :limits="limit"
        :messages="messages ?? []"
        :total="total"
        :loading="loading"
        :extends="['sent_at', 'preview', 'flow']"
        @update:page="handlePageChange"
        @update:limits="handleLimitChange"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
